import { render } from "./UpgradePlan.vue?vue&type=template&id=5a64c6ca&scoped=true"
import script from "./UpgradePlan.vue?vue&type=script&lang=js"
export * from "./UpgradePlan.vue?vue&type=script&lang=js"

import "./UpgradePlan.vue?vue&type=style&index=0&id=5a64c6ca&lang=scss&scoped=true"

import exportComponent from "/home/blissfulapps/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a64c6ca"]])

export default __exports__